import { defineMessages } from 'react-intl';

const messages = defineMessages({
  landingTitle: {
    id: 'N4F7wO',
    defaultMessage: 'Welcome to SPSS Purchasing Advisor',
  },
  landingSubTitle: {
    id: 's9lCbz',
    defaultMessage:
      'Use the assessment below to find out how to purchase the most relevant SPSS Statistics License for you',
  },
  landingText1: {
    id: 'WYFYDF',
    defaultMessage: 'What describes you the best?',
  },
  tile_label1: {
    id: 'r8/S+8',
    defaultMessage: 'Professional',
  },
  tile_info1: {
    id: '6V3XXJ',
    defaultMessage: 'looking to buy multiple licenses for my business',
  },
  tile_label2: {
    id: 'ZlpH/D',
    defaultMessage: 'Researcher / Independent user',
  },
  tile_info2: {
    id: 'MIkJEM',
    defaultMessage: 'looking to buy one license',
  },
  tile_label3: {
    id: 'UvFUuq',
    defaultMessage: 'Student',
  },
  tile_label4: {
    id: 'utaPFN',
    defaultMessage: 'Educator',
  },
  tile_info4: {
    id: 'wvjIjd',
    defaultMessage: 'looking to buy licenses for my campus',
  },
  tile_label5: {
    id: 'XIAdTf',
    defaultMessage: 'Current user',
  },
  tile_info5: {
    id: 'oUyVDr',
    defaultMessage: 'looking to add to my current package',
  },
  learn_about: {
    id: '4vHdX+',
    defaultMessage: 'Learn about: ',
  },
  landing_tooltip1_text: {
    id: 'CFzXwN',
    defaultMessage: 'License Types',
  },
  landing_tooltip2_text: {
    id: 'wuu0DA',
    defaultMessage: 'User Types',
  },
  landing_tooltip1_label1: {
    id: 'XctN1N',
    defaultMessage: 'Perpetual License',
  },
  landing_tooltip1_info1: {
    id: '7qgMyf',
    defaultMessage:
      "You can pay a single one-off fee. This covers the cost of the software and the first year's maintenance. At the end of the year, you can choose to renew your maintenance contract, or let it lapse. You would have access to the software in perpetuity, but not have access to support, maintenance, upgrades, and patches if you did not renew Software & Support.",
  },
  landing_tooltip1_label2: {
    id: 'Cj3D20',
    defaultMessage: 'Subscription License',
  },
  landing_tooltip1_info2: {
    id: '87NXXz',
    defaultMessage:
      'A type of software license offered from a minimum of 12 months to a maximum of 60 months at a time. It is non-cancellable for the term of the contract.',
  },
  landing_tooltip1_label3: {
    id: '4yuW48',
    defaultMessage: 'Monthly & Annual Subscription Online Purchase',
  },
  landing_tooltip1_info3: {
    id: 'whQS8W',
    defaultMessage:
      'Available to purchase online for commercial use only. You must purchase a Base subscription with 3 optional add-ons. Each add-on contains different modules. There are two terms: monthly and annual. This type of subscription requires online access as there are no authorization keys and subscription verification is done with an IBMid and internet connectivity.',
  },
  landing_tooltip2_label1: {
    id: 'AIKmSS',
    defaultMessage: 'Authorized User',
  },
  landing_tooltip2_info1: {
    id: '9bJ5L9',
    defaultMessage:
      'An Authorized User is a unique person who is given access to the Program. The Program may be installed on any number of computers or servers and each Authorized User may have simultaneous access to any number of instances of the Program at one time.',
  },
  landing_tooltip2_label2: {
    id: 'ZK3GDb',
    defaultMessage: 'Concurrent User',
  },
  landing_tooltip2_info2: {
    id: 'eb2ipk',
    defaultMessage:
      'A Concurrent User is a person who is accessing the Program at any particular point in time. Regardless of whether the person is simultaneously accessing the Program multiple times, the person counts only as a single Concurrent User. The Program may be installed on any number of computers or servers, but Licensee must obtain entitlements for the maximum number of Concurrent Users simultaneously accessing the Program.',
  },
  landingText2: {
    id: 'aixNDi',
    defaultMessage: 'SPSS Purchasing Advisor',
  },
  ques1_text: {
    id: 'reBpTR',
    defaultMessage:
      'Select which of the following features is the most important to you',
  },
  ques2_text: {
    id: 'sxIwhJ',
    defaultMessage: 'Choose the selection of features required.',
  },
  ques2_italic_text: {
    id: 'zwhzKI',
    defaultMessage: 'Multiple selection possible',
  },
  ques2_stats_base_text: {
    id: 'PsVH/F',
    defaultMessage: 'Statistics Base',
  },
  ques2_data_prep_text: {
    id: '7QPHul',
    defaultMessage: 'Data Preparation',
  },
  ques2_boot_strap_text: {
    id: 'fEQ0Rh',
    defaultMessage: 'Boot strapping',
  },
  ques2_adv_stats_text: {
    id: 'wtDShI',
    defaultMessage: 'Advanced Statistics',
  },
  ques2_regression_text: {
    id: 'HfQFgK',
    defaultMessage: 'Regression',
  },
  ques2_custom_table_text: {
    id: 'VT5aPt',
    defaultMessage: 'Custom Tables',
  },
  ques2_miss_val_text: {
    id: 'pm3udo',
    defaultMessage: 'Missing Value',
  },
  ques2_catg_text: {
    id: 'VKb1MS',
    defaultMessage: 'Categories',
  },
  ques2_forecasting_text: {
    id: 'BjiJ1E',
    defaultMessage: 'Forecasting',
  },
  ques2_comp_samp_text: {
    id: 'VhGbQB',
    defaultMessage: 'Complex Samples',
  },
  ques2_decs_tree_text: {
    id: '3fy1pJ',
    defaultMessage: 'Decision Trees',
  },
  ques2_conjoint_text: {
    id: '2jO9LY',
    defaultMessage: 'Conjoint',
  },
  ques2_neural_network_text: {
    id: 'cC3494',
    defaultMessage: 'Neural Networks',
  },
  ques2_direct_markt_text: {
    id: 'jEb0oC',
    defaultMessage: 'Direct Marketing',
  },
  ques2_exact_test_text: {
    id: 'MGV/Jf',
    defaultMessage: 'Exact Tests',
  },
  std_tile_title_text: {
    id: 'Rht1l/',
    defaultMessage:
      'To learn more about obtaining a student license of SPSS Statistics please visit our student page',
  },
  std_link_text: {
    id: 'KB/QJu',
    defaultMessage: 'IBM SPSS Statistics GradPack and Faculty Packs',
  },
  educator_tile_title_text: {
    id: 'mJjMsD',
    defaultMessage:
      'To learn more about campus purchasing options, visit our site for educators',
  },
  educator_link_text: {
    id: 'tXXQLL',
    defaultMessage: 'IBM SPSS Statistics for Academic Institutions',
  },
  perp_subs_title_text: {
    id: 'jxTW/f',
    defaultMessage: 'For adding a package, contact Sales',
  },
  perp_subs_title_text2: {
    id: 'r9cnYi',
    defaultMessage:
      'For choosing any specific module under Perpetual/Subscription License purchase, contact a seller',
  },
  perp_subs_link_text: {
    id: '9ndIuI',
    defaultMessage: 'Contact an IBM representative',
  },
  buy_now_text: {
    id: 'lCILNz',
    defaultMessage: 'Buy Now',
  },
  sass_link_text: {
    id: 'GzUS7h',
    defaultMessage: 'IBM SPSS Statistics Subscription ',
  },
  spss_stats_pkg_text: {
    id: 'YM02QM',
    defaultMessage:
      'This is the best SPSS Statistics Package for you: Perpetual/Subscription license with',
  },
  email_sale_text: {
    id: 'l+EKej',
    defaultMessage: 'Email Sales',
  },
  purchase_text: {
    id: 'XoMtBI',
    defaultMessage: 'To purchase get connected with our sales team',
  },
  saas_purchase_text: {
    id: 'G/ipH0',
    defaultMessage:
      'By the way, you can temporarily work offline with Monthly & Annual Subscription',
  },
  spss_stats_base_title_text: {
    id: 'LopkdD',
    defaultMessage:
      'This is the best SPSS Statistics Package for you: SPSS Statistics Base Subscription',
  },
  note_checkbox_text: {
    id: 'lSiqME',
    defaultMessage: 'Note: Only Authorized User License Type is available.',
  },
  note_radio_text: {
    id: 'OCKcvP',
    defaultMessage: 'Note: You can purchase as an Authorized User',
  },
  note2_radio_text: {
    id: 'CH4Npu',
    defaultMessage: 'and a Concurrent User',
  },
  spss_stats_ques_text: {
    id: 'OPRfkG',
    defaultMessage: 'Which SPSS Statistics Package do you currently have?',
  },
  feat_ans1: {
    id: 'EUjkYu',
    defaultMessage: 'Ability to work offline',
  },
  feat_ans2: {
    id: 'SeV5Xk',
    defaultMessage:
      'Require additional processing speeds from SPSS Statistics Server',
  },
  feat_ans3: {
    id: 'c7MMhJ',
    defaultMessage: 'Ability to reassign licenses with ease',
  },
  feat_ans4: {
    id: 'fiyo3b',
    defaultMessage: 'Flexible pricing and add-ons',
  },
  feat_ans5: {
    id: 'j7LMCd',
    defaultMessage: 'No License Keys',
  },
  feat_ans6: {
    id: 'vcrD3o',
    defaultMessage: 'None of the above',
  },
  spss_stats_ans1: {
    id: 'XctN1N',
    defaultMessage: 'Perpetual License',
  },
  spss_stats_ans2: {
    id: 'Cj3D20',
    defaultMessage: 'Subscription License',
  },
  spss_stats_ans3: {
    id: '4yuW48',
    defaultMessage: 'Monthly & Annual Subscription Online Purchase',
  },
  addon_feat_ans1: {
    id: 'cBtCEk',
    defaultMessage: 'Base only',
  },
  addon_feat_ans2: {
    id: 'JtUWsB',
    defaultMessage: 'Advanced Statistics, Regression and Custom Tables',
  },
  addon_feat_ans3: {
    id: 'gmFFU5',
    defaultMessage:
      'Missing values, Categories, Complex Samples, Conjoint and Exact Tests',
  },
  addon_feat_ans4: {
    id: 'IoSQy8',
    defaultMessage:
      'Forecasting, Decision Trees, Neural Networks and Direct Marketing',
  },
  order_text: {
    id: 'r4tIGb',
    defaultMessage: 'Request a quote',
  },
  drawer_close: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  launch_btn_text: {
    id: '/aBLH2',
    defaultMessage: 'Get started',
  },
  start_over: {
    id: 'i4joXC',
    defaultMessage: 'Start Over',
  },
  back_btn: {
    id: 'cyR7Kh',
    defaultMessage: 'Back',
  },
  next_btn: {
    id: '9+Ddtu',
    defaultMessage: 'Next',
  },
  close_btn: {
    id: 'rbrahO',
    defaultMessage: 'Close',
  },
  thank_text: {
    id: 'YRLPyq',
    defaultMessage: 'Thank you for submitting the form!',
  },
  foundCountry: {
    id: 'q0Y/L/',
    defaultMessage: 'Found country',
  },
  accessPage: {
    id: 'Z02o6s',
    defaultMessage: 'access page in',
  },
  accessPageCapitalized: {
    id: 'GjxKEi',
    defaultMessage: 'Access page in',
  },
  availableIn: {
    id: '1oELRa',
    defaultMessage:
      'The SPSS Purchasing Advisor Self Assessment is available in',
  },
  localCurrency_text: {
    id: '35V5JI',
    defaultMessage: 'with local currency',
  },
  takeMeThere: {
    id: 'GeEQEA',
    defaultMessage: 'Take me there',
  },
  stayHere: {
    id: 'ObupdK',
    defaultMessage: 'Stay here',
  },
  bp_title: {
    id: 'BkHBGW',
    defaultMessage: 'Selected Business Partner',
  },
  return_assessment: {
    id: 'acrOoz',
    defaultMessage: 'Continue',
  },
  landing_title: {
    id: 'U9suL3',
    defaultMessage: 'Get tailored recommendations on purchase options.',
  },
});

export default messages;
